export default class AttendanceFlowApprovalDat {
  recordIds: Array<string>;
  approvalFlg: string;
  constructor(recordIds: Array<string>, approvalFlg: string) {
    this.recordIds = recordIds;
    this.approvalFlg = approvalFlg;
  }
}
